import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon/Icon.h'
import { COLOR, INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IInlineBackAngleWithTitleProps extends IButtonProps {}

export const InlineBackAngleWithTitle = ({
  title = '',
  icon = IconNames.angleLeft,
  iconPosition = IconPositions.Left,
  iconSize = ButtonIconSizes.small,
  corners = ButtonCorners.CORNERS_10,
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button2,
  fluid = ButtonFluid.None,
  ...rest
}: IInlineBackAngleWithTitleProps): JSX.Element | null =>
  title ? (
    <Button
      title={title}
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={corners}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      paddings={[INDENTS.INDENT_0]}
      fluid={fluid}
      {...rest}
    />
  ) : null
